import React, { FC } from 'react';
import { LegacySelfcareRedirectTrigger } from '../Utils/SelfSubmittinForm';

export const EmailManagementRedirect: FC = (props) => {
	return (
		<div>
			{/* <h2>Sähköpostinhallinnan uudelleen ohjaus</h2>
			<div>Tämä on uudelleenohjaus-sivu joka vie käyttäjän Sähköpostinhallintaan.</div> */}
			<LegacySelfcareRedirectTrigger />
		</div>
	);
};
